<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M12.9193 6.2487C12.9193 7.85953 11.6134 9.16537 10.0026 9.16537C8.39177 9.16537 7.08594 7.85953 7.08594 6.2487C7.08594 4.63786 8.39177 3.33203 10.0026 3.33203C11.6134 3.33203 12.9193 4.63786 12.9193 6.2487Z"
      fill="currentColor"
    />
    <path
      d="M15 13.7487C15 15.3595 12.7614 16.6654 10 16.6654C7.23857 16.6654 5 15.3595 5 13.7487C5 12.1379 7.23857 10.832 10 10.832C12.7614 10.832 15 12.1379 15 13.7487Z"
      fill="currentColor"
    />
    <path
      d="M5.93497 4.16406C6.08286 4.16406 6.22723 4.17857 6.36664 4.2062C6.02701 4.80945 5.83326 5.5058 5.83326 6.2474C5.83326 6.97094 6.01769 7.65141 6.34209 8.24436C6.21031 8.26892 6.0742 8.28178 5.93497 8.28178C4.75629 8.28178 3.80078 7.36 3.80078 6.22292C3.80078 5.08585 4.75629 4.16406 5.93497 4.16406Z"
      fill="currentColor"
    />
    <path
      d="M4.54075 15.8216C4.06749 15.2558 3.7513 14.5616 3.7513 13.7499C3.7513 12.9631 4.04844 12.2866 4.49779 11.7305C2.91055 11.8536 1.66797 12.7217 1.66797 13.7744C1.66797 14.8369 2.93239 15.7114 4.54075 15.8216Z"
      fill="currentColor"
    />
    <path
      d="M14.1661 6.2474C14.1661 6.97094 13.9817 7.65141 13.6573 8.24436C13.7891 8.26892 13.9252 8.28178 14.0645 8.28178C15.2431 8.28178 16.1986 7.36 16.1986 6.22292C16.1986 5.08585 15.2431 4.16406 14.0645 4.16406C13.9166 4.16406 13.7722 4.17857 13.6328 4.2062C13.9724 4.80945 14.1661 5.5058 14.1661 6.2474Z"
      fill="currentColor"
    />
    <path
      d="M15.4609 15.8216C17.0693 15.7114 18.3337 14.8369 18.3337 13.7744C18.3337 12.7217 17.0911 11.8536 15.5039 11.7305C15.9532 12.2866 16.2504 12.9631 16.2504 13.7499C16.2504 14.5616 15.9342 15.2558 15.4609 15.8216Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'TeamAllocationIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>